import React from "react";
import HubspotForm from "react-hubspot-form";
import "../../assets/css/components/RequesrAccess/RequestAccess.css";
import headBg from "../../../src/assets/images/header_bar_bg.png";

function RequestAccess() {
  const removeErrorMessage = () => {};
  return (
    <div className="loginBackground">
      <div className="request-form-wrapper">
        <h1>Request Customer Portal Access</h1>
        <div className="head_txtimg">
          <img src={headBg} alt="portal.jpg" className="img-responsive" />
          <script
            type="text/javascript"
            id="hs-script-loader"
            async
            defer
            src="//js.hs-scripts.com/409433.js"
          />
        </div>
        <HubspotForm
          portalId="409433"
          formId="0fa5f24a-903d-437d-9d0b-ef20e780ebba"
          onFormReady={() => removeErrorMessage()}
          onSubmit={() => console.log("submit")}
          loading={<div>Loading...</div>}
        />
        <p className="term_txt">
          <a
            rel="noopener noreferrer"
            href="https://www.izenda.com/privacy-notice/"
            target="_blank"
          >
            Terms and Privacy Statement
          </a>
        </p>
      </div>
    </div>
  );
}

export default RequestAccess;



// WEBPACK FOOTER //
// ./src/components/RequestAccess/RequestAccess.jsx